import React from 'react';
import HeroList from '../components/hero/HeroList';

export default function MarvelScreen() {
	return (
		<div>
			<HeroList publisher='Marvel Comics' />
		</div>
	);
}
